import React from "react";
import "../styles/Profile.css";
import profilePic from "../images/portfolio/profile.jpg";

const Profile = () => {
  return (
    <div className="profileContainer">
      <div className="profile">
        <img src={profilePic} alt="profile" />
        <span>
          <span className="redBracket">[</span>
          Xəyal Isaxanov
          <span className="redBracket">]</span>
        </span>
        <p className="info">
          <span className="redBracket">[</span>
          Javascript(ES6+), React, Redux, PHP, MySQL
          <span className="redBracket">]</span>
        </p>
      </div>
    </div>
  );
};

export default Profile;
